import React from 'react';
import { ButtonV2, DialogV2, Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Bank } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import PoweredByStripe from '@assets/PoweredbyStripe.png';
import { useCreditCardSetupTelemetry } from '../CreditCardSetUp.telemetry';
import { useCreditCardSetupContext } from '../CreditCardSetUp.context';
import { useMount } from '@shared/utils/hooks/useMount';

interface ReadyToUseProps {
  onClose: () => void;
}

export const ReadyToUse: React.FC<ReadyToUseProps> = ({ onClose }) => {
  const { tq } = useTranslation('sharedRegistry');
  const { onOpenTransferToBankDialog } = useCreditCardSetupContext();

  const telemetry = useCreditCardSetupTelemetry();
  useMount(() => {
    telemetry.creditCardSetupDialog.enter('success');
  });
  return (
    <DialogV2.Body>
      <Flex
        marginX="auto"
        paddingX={7}
        maxWidth="540px"
        width="100%"
        paddingTop={10}
        paddingBottom={8}
        flexDirection="column"
        alignItems="center"
      >
        <IconV2
          size="xxl"
          color="mono14"
        >
          <Bank />
        </IconV2>
        <TextV2
          marginY={2}
          textAlign="center"
          typographyVariant="display2"
          color="mono14"
        >
          {tq`Payout method added!`}
        </TextV2>
        <TextV2
          textAlign="center"
          typographyVariant="body3"
          color="mono12"
        >
          {tq`Your bank account (or debit card) is connected and ready to go. Click Transfer to Bank to start moving your funds.`}
        </TextV2>
        <ButtonV2
          onClick={() => {
            telemetry.transferToBankButtonClicked();
            onClose();
            onOpenTransferToBankDialog();
          }}
          marginTop={10}
          marginBottom={8}
          shape="rounded"
          intent="neutral"
        >
          {tq`Transfer to Bank →`}
        </ButtonV2>
        <img
          src={PoweredByStripe}
          title="Stripe"
          alt="stripe"
        />
      </Flex>
    </DialogV2.Body>
  );
};
